import { render, staticRenderFns } from "./NavLinks.vue?vue&type=template&id=22b693da&scoped=true&"
import script from "./NavLinks.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NavLinks.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./NavLinks.vue?vue&type=style&index=0&id=22b693da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b693da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b693da')) {
      api.createRecord('22b693da', component.options)
    } else {
      api.reload('22b693da', component.options)
    }
    module.hot.accept("./NavLinks.vue?vue&type=template&id=22b693da&scoped=true&", function () {
      api.rerender('22b693da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreSearch/components/NavLinks.vue"
export default component.exports